import React from 'react';
import PropTypes from 'prop-types';
import {I18nUtils} from "../../../i18n/I18nUtils";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import * as importOutsourcesActions from "../actions/importOutsourceActions";

class ImportOutsourceRow extends React.Component {

  constructor(props){
    super(props);
    this.onClickImport = this.onClickImport.bind(this);
  }

  onClickImport(outsource){
    this.props.importOutsourcesActions.importOutsource(outsource);
  }

  render() {
    const { outsource } = this.props;
    return (
      <tr>
        <td>{outsource.code}</td>
        <td>{outsource.name}</td>
        <td><strong>{outsource.cif}</strong></td>
        <td>
          <a
            className="btn btn-default btn-block btn-sm waves-effect waves-float"
            onClick={() => this.onClickImport(outsource)}
          >{I18nUtils.tr('TR_IMPORTAR')}</a>
        </td>
      </tr>
    );
  }

}

const mapDispatchToProps = dispatch => ({
  importOutsourcesActions: bindActionCreators(importOutsourcesActions, dispatch),
});

export default connect(null, mapDispatchToProps)(ImportOutsourceRow);

ImportOutsourceRow.propTypes = {
  outsource: PropTypes.objectOf(PropTypes.any).isRequired,
};

ImportOutsourceRow.defaultProps = {
};



// WEBPACK FOOTER //
// ./src/app/outsource/components/ImportOutsourceRow.js